import { Table } from '@components/primitives/Chart/Table'
import { Text } from '@components/primitives/Text'
import type { DrugLabelData } from '@modules/drugs/helpers/getTreatmentPageData'

export const TreatmentOverview = ({
  drugLabelData,
  drugName,
}: {
  drugLabelData: DrugLabelData
  drugName: string
}) => {
  return (
    <div className='py-4'>
      <Text
        className='py-2'
        styleName={'h4'}
        value={`${drugName} Overview & Background`}
      />
      <Table
        borderClass='border-neutral100'
        headerBackground='bg-neutral50'
        headerRow={[
          'Brand Name',
          'Generic Name',
          'First FDA Approval',
          'How many FDA approvals?',
        ]}
        rows={[
          [
            <span className='border-b' key={drugLabelData.brandName}>
              {drugLabelData.brandName}
            </span>,
            drugLabelData.genericName,
            drugLabelData.firstFdaApproval,
            drugLabelData.fdaApprovalCount,
          ],
        ]}
        textColor='text-neutral500'
      />
    </div>
  )
}
